import { render, staticRenderFns } from "./CollectionView.vue?vue&type=template&id=2248c227&scoped=true&"
import script from "./CollectionView.vue?vue&type=script&lang=js&"
export * from "./CollectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2248c227",
  null
  
)

export default component.exports